import React from 'react';
import ReadCookie from '../../../functions/readcookies';
import $ from "jquery";
import Webserver from '../../../functions/server';
import Add from '../PlaceOrder/add';
import Loading from '../../loadings';
import TCSValue from '../../../functions/tcsvalue';

class Title extends React.Component {

  state = {
    quotationDetails: [], dialog: false, items: [],
    data: [], paymentmode: [], datasss: [],
    userId: (ReadCookie("vaigai")).id
  }


  getPaymentMode() {
    let context = this;
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    let items = [];
    items = JSON.stringify(items);
    context.createCookie('placeorderitems', items, 7);
    let userId = this.state.userId
    context.setState({ load: true, message: 'Getting Paymentmode!!!' })
    $.ajax({
      type: 'POST', data: { 'executiveid': userId, 'branchId': branch_id },
      url: Webserver() + 'modecontrol/getmode.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ paymentmode: data, load: false });
          context.getPartCode();
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  getPartCode() {
    let context = this;

    let data = (ReadCookie("branch"));
    let branch_id;
    if (!data) {
      alert('Please Reload!!!');
      return;
    }
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    context.setState({ load: true, message: 'Getting Partcode!!!' });

    $.ajax({
      type: 'POST',
      data: { 'branch': branch_id, 'customer': 96 },
      url: Webserver() + 'purchasedetail/getpartcodeedit.php',
      success: function(data) {
        console.log(data);
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ data: data });

          context.editPart();
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err) {
        context.setState({ load: false })
        alert('Try again!!!!')
      }
    });
  }

  editPart() {
    let quotationId = this.props.quotationId;
    let context = this;
    let data1 = { 'id': quotationId, 'masterId': 0 };
    context.setState({ load: true,  message: 'Getting Quotation details!!!' });

    $.ajax({
      type: 'POST', data: data1,
      url: Webserver() + 'quotation/getorder.php',
      success: function(data) {
        
        context.setState({ load: false });
        let remarks = '';
        try {
          data = JSON.parse(data);
          console.log(data);
        
          let array = context.state.data;
          if (!array) {
            alert('Please Reload!!!');
            return;
          }
          let total = 0;
          let ii = 1;
          let o = 0;
          for (var j = 0; j < array.length; j++) {
            for (var i = 0; i < data.length; i++) {
              
              if (data[i].spid == '0' || data[i].spid == 0) {
                
                let quantity = 1;
                let mrp = Number(data[i].uprice);
                let tax = Number(data[i].tax);
                let sum = quantity * mrp;
                let ss = sum - ((sum * 0)/100);
                remarks = data[i].info;
                data[i].id = i;
                data[i].aliasId = '';
                data[i].ava_stocks = '';
                data[i].branch = '';
                data[i].brand = '';
                data[i].brand_name = '';
                data[i].discountper = 0;
                data[i].discountrs = 0;
                data[i].orderdetailsId = data[i].orderdetailsId;
                data[i].part_id = 0;
                data[i].partcode = '0';
                data[i].partname = data[i].info;
                data[i].partno = '0';
                data[i].point = 0;
                data[i].quantity = 1;
                data[i].rackno = '';
                data[i].status = "Othercharge";
                data[i].tax = data[i].tax;;
                data[i].weight = 0;
                data[i].orderdetailsId = data[i].orderdetailsId;

              }
              else {
                if (data[i].partnumber == array[j].partno && array[j].brand_name == data[i].brandname) {
                  let quantity = Number(data[i].qty);
                  let mrp = Number(array[j].mrp);
                  let tax = Number(array[j].tax);
                  let sum = quantity * mrp;
                  let ss = sum - ((sum * 0)/100);
                  data[i].id = ii++;
                  remarks = data[i].info;
                  data[i].branch = 0;
                  data[i].adjstock = array[j].adjstock;
                  data[i].discountper = data[i].discper;
                  data[i].discountrs = data[i].disc;
                  data[i].orderdetailsId = data[i].orderdetailsId;
                  data[i].part_id = 0;
                  data[i].quantity = data[i].qty;
                  data[i].oldquantity = data[i].qty;
                  data[i].status = "Pending For Delivery";
                  data[i].tax = array[j].tax;
                  if (data[i].cancelledinvoice == 1) {

                  }
                  else {
                    data[i].uprice = array[j].mrp;
                  }
                  data[i].weight = array[j].weight;
                  data[i].rackno = array[j].rackno;
                  data[i].partcode = array[j].spare_name;
                  data[i].adjstock = array[j].adjstock;
                  data[i].partname = array[j].spare_name;
                  data[i].partno = array[j].partno;
                  data[i].point = array[j].point;
                  data[i].brand = array[j].brand_id;
                  data[i].brand_name = array[j].brand_name;
                  data[i].dropdown = array[j].part_alias+'->'+array[j].spare_name;
                  data[i].aliasId = array[j].id;
                  data[i].ava_stocks = array[j].ava_stocks; 
                }
              }
            }
            o = o + 1;
          }
          context.setState({ originalData: data, items: data, removedData: [], remarks, dialog: true });
          data = JSON.stringify(data);
          context.createCookie('placeorderitems', data, 7);
          return;
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err) {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
  }

  convertToNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  makeDecimalPoint(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  createCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + ";path=/";
  }

  handleClose() { this.setState({ dialog: false }) }

  updateItems(data) { this.setState({ items: data }) }

  updateAndClose() {
    this.setState({ dialog: false })
    this.props.getQuotation();
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <div onClick={this.getPaymentMode.bind(this)}>Yes</div>
        { (this.state.dialog == false) ?
          (<div></div>) :
          (
            <div>
              <Add partcodeOption={this.state.data} otherChargeAmount={this.state.otherChargeAmount} handleClose={this.handleClose.bind(this)}
                  executiveId={this.state.executiveId} removedData={this.state.removedData} remarks={this.state.remarks}
                  quotationId={this.props.quotationId} partcode={this.state.data} masterId={this.props.masterId} updateAndClose={this.updateAndClose.bind(this)}
                  items={this.state.items} updateItems={this.updateItems.bind(this)} from='edit' fromDisplay='none' customerPoints={this.props.customerpoints}
                  customerId={this.props.customerId} customerTCS={this.props.customerTCS} customer={this.props.customerId} dialog={this.state.dialog} paymentmode={this.state.paymentmode} />
            </div>
          )
        }

      </div>
    );
  }
}

export default Title;
